<template>
  <v-dialog v-model="dialog" persistent max-width="100%">
    <v-card>
      <v-card-title class="pt-2 pb-0">{{ tituloModal }}</v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text class="pb-0">
        <v-row dense>
          <v-col cols="12" md="6">
            <span class="h5 d-block"> <strong>Solicitud N°: </strong>{{ form.numero }} </span>
            <span class="h5 d-block"> <strong>Solicitante: </strong>{{ form.user }} </span>
            <span class="h5 d-block"> <strong>Fecha Solicitud: </strong>{{ form.created_at }} </span>
          </v-col>

          <v-col cols="12" md="6">
            <span class="h5 d-block"> <strong>Estado Solicitud: </strong>{{ form.estado }} </span>
            <span class="h5 d-block">
              <strong>Tipo Solicitud: </strong>{{ form.tipo == tipoSolicitudRecursos ? 'Sedes' : 'Nacional' }}
            </span>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <ag-grid-vue
              :gridOptions="gridOptions"
              class="ag-theme-balham ag-grid-table-procesar-solicitudes"
              :columnDefs="definicionColumnas"
              :defaultColDef="defaultColDef"
              @grid-ready="onGridReady"
              :rowData="form.detalle_solicitud"
              :suppressRowClickSelection="true"
              colResizeDefault="shift"
              :animateRows="true"
              :floatingFilter="false"
              :rowClassRules="rowClassRules"
              :pinnedBottomRowData="pinnedBottomRowData"
              :alwaysShowVerticalScroll="true"
              :suppressPaginationPanel="true"
              @rowClicked="onRowClicked($event)"
              @first-data-rendered="onFirstDataRendered">
            </ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-2"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrarModal()"> Cerrar </v-btn>
        <v-btn v-if="!verificar" color="blue darken-1" text @click.prevent="validar()"> Guardar </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionAccion"
      :titulo="accion.titulo"
      :mensaje="accion.mensaje"
      :realizandoAccion="accion.realizandoAccion"
      @cerrar="cerrarAccion"
      @aceptar="aceptarAccion">
      <v-form v-if="mostrarObservaciones">
        <v-row>
          <v-col cols="12" style="padding-bottom: 0px !important">
            <v-textarea
              ref="observacionRef"
              outlined
              name="Observacion"
              label="Observacion"
              hide-details
              v-model="observaciones"></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </ConfirmacionAccion>

    <ModalRechazarImporte
      ref="modalRechazarMonto"
      @actualizarEstdoDetalleSolicitud="actualizarEstdoDetalleSolicitud"></ModalRechazarImporte>

    <ModalCambioCuentas
      ref="modalCambioCuentas"
      @actualizarEstdoDetalleSolicitud="actualizarEstdoDetalleSolicitud"></ModalCambioCuentas>

    <ModalVerPdf ref="modalVerPdfRef" />

    <ModalRegistrarPagoDetalleSolicitud
      ref="ModalRegistrarPagoDetalleSolicitudRef"
      @establecerEstado="actualizarEstdoDetalleSolicitud" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import {
  ESTADOS_DETALLE_SOLICITUD,
  formatearValorAMoneda,
  obtenerColorEstadoDetalleSolicitud,
  OPERACIONES_DETALLE_SOLICITUD,
  TIPOS_SOLICITUD,
} from '../utils';
import modalSolicitudRecursosMixin from '../mixins/modal-solicitud-recursos-mixin';
import ModalRechazarImporte from './ModalRechazarImporte.vue';
import ModalCambioCuentas from './ModalCambioCuentas.vue';
import ModalVerPdf from './ModalVerPdf';
import { mapGetters } from 'vuex';

export default {
  name: 'ModalFormSolicitudTransferencia',
  mixins: [modalSolicitudRecursosMixin],
  components: {
    ModalRechazarImporte,
    ModalCambioCuentas,
    ModalVerPdf,
  },
  data() {
    return {
      tipoSolicitud: '',
      tipoSolicitudRecursos: TIPOS_SOLICITUD.RECURSOS,
      itemSeleccionado: null,
      columnDefs: [
        {
          headerName: '#',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              return param.node.rowIndex + 1;
            }
          },
          filter: false,
          minWidth: 50,
          maxWidth: 50,
        },
        {
          headerName: 'SEDE ORIGEN',
          field: 'sede_origen',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'BANCO ORIGEN',
          field: 'banco_origen',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'CUENTA ORIGEN',
          field: 'cuenta_origen',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'SEDE DESTINO',
          field: 'sede_destino',
          filter: false,
          singleClickEdit: true,
          minWidth: 140,
        },
        {
          headerName: 'BANCO DESTINO',
          field: 'banco_destino',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'CUENTA DESTINO',
          field: 'cuenta_destino',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          minWidth: 160,
        },
        {
          headerName: 'CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 160,
        },
        {
          headerName: 'DETALLE',
          field: 'detalle',
          editable: function (param) {
            return !param.node.rowPinned && param.data.estado == ESTADOS_DETALLE_SOLICITUD.PENDIENTE;
          },
          singleClickEdit: true,
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'IMPORTE',
          field: 'importe',
          type: 'rightAligned',
          editable: function (param) {
            return param.node.rowPinned
              ? false
              : param.data.estado != ESTADOS_DETALLE_SOLICITUD.APROBADO
              ? true
              : false;
          },
          singleClickEdit: true,
          valueFormatter: function (param) {
            return formatearValorAMoneda(param.value);
          },
          valueParser: numberParser,
          filter: false,
          minWidth: 100,
        },
        {
          headerName: 'SALDO',
          field: 'saldo',
          type: 'rightAligned',
          valueFormatter: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            }
            return formatearValorAMoneda(param.value);
          },
          filter: false,
          minWidth: 100,
        },
        {
          headerName: 'ADJUNTO',
          filter: false,
          cellRenderer: (params) => {
            const archivoId = params.data.archivo_id;

            if (params.node.rowPinned) {
              return undefined;
            } else if (!archivoId) {
              return /*html */ `<span>-</span>`;
            } else if (this.recuperandoArchivoAdjunto && this.detalleSeleccionadoId === params.data.id) {
              return /*html */ `
                <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear v-progress-linear--visible theme--dark" style="margin-top: 8px; height: 8px;">
                  <div class="v-progress-linear__background primary" style="opacity: 0.3; left: 0%; width: 100%;"></div>
                  <div class="v-progress-linear__buffer"></div>
                  <div class="v-progress-linear__indeterminate v-progress-linear__indeterminate--active">
                    <div class="v-progress-linear__indeterminate long primary"></div>
                    <div class="v-progress-linear__indeterminate short primary"></div>
                  </div>
                </div>`;
            } else {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small blue--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO}">
                      ADJUNTO
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-file-outline"></i>
                  </span>
              </button>`;
            }
          },
          minWidth: 125,
          maxWidth: 125,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              const color = obtenerColorEstadoDetalleSolicitud(param.data.estado);

              return /*html */ `<span style="color: ${color};">${param.data.estado}</span>`;
            }
          },
          filter: false,
          minWidth: 110,
          maxWidth: 110,
        },
        {
          headerName: '',
          filter: false,
          minWidth: 125,
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else if (param.data.estado == ESTADOS_DETALLE_SOLICITUD.PENDIENTE) {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small error--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.REMOVER}">
                      REMOVER
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-close"></i>
                  </span>
              </button>`;
            } else {
              return undefined;
            }
          },
        },
      ],
      columnDefsVerificar: [
        {
          headerName: '#',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              return param.node.rowIndex + 1;
            }
          },
          filter: false,
          minWidth: 50,
          maxWidth: 50,
        },
        {
          headerName: 'SEDE ORIGEN',
          field: 'sede_origen',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'BANCO ORIGEN',
          field: 'banco_origen',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'CUENTA ORIGEN',
          field: 'cuenta_origen',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'SEDE DESTINO',
          field: 'sede_destino',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'BANCO DESTINO',
          field: 'banco_destino',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'CUENTA DESTINO',
          field: 'cuenta_destino',
          filter: false,
          minWidth: 140,
        },
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          minWidth: 160,
        },
        {
          headerName: 'CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 160,
        },
        {
          headerName: 'DETALLE',
          field: 'detalle',
          filter: false,
          minWidth: 200,
        },
        {
          headerName: 'IMPORTE',
          field: 'importe',
          type: 'rightAligned',
          valueFormatter: function (param) {
            return formatearValorAMoneda(param.value);
          },
          valueParser: numberParser,
          filter: false,
          minWidth: 100,
        },
        {
          headerName: 'SALDO',
          field: 'saldo',
          type: 'rightAligned',
          valueFormatter: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            }
            return formatearValorAMoneda(param.value);
          },
          filter: false,
          minWidth: 100,
        },
        {
          headerName: 'ADJUNTO',
          filter: false,
          cellRenderer: (params) => {
            const archivoId = params.data.archivo_id;

            if (params.node.rowPinned) {
              return undefined;
            } else if (!archivoId) {
              return /*html */ `<span>-</span>`;
            } else if (this.recuperandoArchivoAdjunto && this.detalleSeleccionadoId === params.data.id) {
              return /*html */ `
                <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="v-progress-linear v-progress-linear--visible theme--dark" style="margin-top: 8px; height: 8px;">
                  <div class="v-progress-linear__background primary" style="opacity: 0.3; left: 0%; width: 100%;"></div>
                  <div class="v-progress-linear__buffer"></div>
                  <div class="v-progress-linear__indeterminate v-progress-linear__indeterminate--active">
                    <div class="v-progress-linear__indeterminate long primary"></div>
                    <div class="v-progress-linear__indeterminate short primary"></div>
                  </div>
                </div>`;
            } else {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small blue--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.VER_ADJUNTO}">
                      ADJUNTO
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-file-outline"></i>
                  </span>
              </button>`;
            }
          },
          minWidth: 125,
          maxWidth: 125,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              const color = obtenerColorEstadoDetalleSolicitud(param.data.estado);

              return /*html */ `<span style="color: ${color};">${param.data.estado}</span>`;
            }
          },
          filter: false,
          minWidth: 150,
          maxWidth: 150,
        },
        {
          headerName: 'PROCESAR',
          filter: false,
          minWidth: 400,
          cellRenderer: (param) => {
            if (param.node.rowPinned) {
              return undefined;
            } else if (param.data.estado == ESTADOS_DETALLE_SOLICITUD.PENDIENTE && this.permisosPresupuestos2) {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small success--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.APROBAR}">
                      APROBAR
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-check"></i>
                  </span>
              </button>
              
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small error--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.RECHAZAR}" >
                      RECHAZAR
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-close"></i>
                  </span>
              </button>
              
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small warning--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.RECHAZAR_MONTO}" >
                      R. IMPORTE
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-close"></i>
                  </span>
              </button>`;
            } else if (param.data.estado == ESTADOS_DETALLE_SOLICITUD.APROBADO && this.permisosPresupuestos2) {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small blue-grey--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.ANULAR}" >
                      ANULAR
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-cancel"></i>
                  </span>
              </button>

              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small deep-purple--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.CAMBIAR_CUENTAS}" >
                      CAMBIAR CUENTAS
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-swap-horizontal"></i>
                  </span>
              </button>
              `;
            } else if (
              [ESTADOS_DETALLE_SOLICITUD.DESEMBOLSADO, ESTADOS_DETALLE_SOLICITUD.PAGADO_PARCIALMENTE].includes(
                param.data.estado,
              ) &&
              (this.permisosPresupuestos1 || this.permisosPresupuestos2)
            ) {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small purple--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.REGISTRAR_PAGO}" >
                      REGISTRAR PAGO
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-cash"></i>
                  </span>
              </button>`;
            } else if (
              ESTADOS_DETALLE_SOLICITUD.PAGADO == param.data.estado &&
              (this.permisosPresupuestos1 || this.permisosPresupuestos2)
            ) {
              return /*html */ `
              <button type="button" style="margin-bottom: 8px;" class="v-btn v-btn--outlined theme--light v-size--x-small purple--text">
                  <span class="v-btn__content" data-action-type="${OPERACIONES_DETALLE_SOLICITUD.VER_PAGO}" >
                      VER PAGOS
                      <i aria-hidden="true" class="v-icon notranslate mdi mdi-cash"></i>
                  </span>
              </button>`;
            } else {
              return undefined;
            }
          },
        },
      ],
    };
  },
  computed: {
    tituloModal() {
      if (!this.verificar) {
        return this.form.id ? 'EDITAR REGISTRO DE EJECUCIÓN DE RECURSOS' : 'REGISTRO DE EJECUCIÓN DE RECURSOS';
      }
      return `PROCESAR REGISTRO DE SOLICITUD`;
    },
    peticionSedeId() {
      return this.agregarDetalle.sede_origen ? this.agregarDetalle.sede_origen.id : null;
    },
    ...mapGetters({
      permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
      permisosPresupuestos2: 'presupuesto/permisosPresupuestos2',
    }),
  },
  methods: {
    async abrirModal(accion, data = []) {
      switch (accion) {
        case 'verificar': {
          this.verificar = true;
          this.form = {
            id: data['id'],
            sede_origen_id: data['sede_origen_id'],
            sede_origen: data['sede_origen'],
            sede_id: data['sede_id'],
            sede: data['sede'],
            numero: data['numero'],
            tipo: data['tipo'],
            total: data['total'],
            user_id: data['user_id'],
            user: data['user'],
            estado: data['estado'],
            created_at: data['created_at'],
            detalle_solicitud: data['detalle_solicitud'].map((detalle) => ({
              id: detalle.id,
              sede_origen_id: detalle.sede_origen_id,
              sede_origen: detalle.sede_origen,
              sede_destino_id: detalle.sede_destino_id,
              sede_destino: detalle.sede_destino,
              cuenta_origen_id: detalle.cuenta_origen_id,
              cuenta_origen: detalle.cuenta_origen,
              banco_origen: detalle.banco_origen,
              cuenta_destino_id: detalle.cuenta_destino_id,
              cuenta_destino: detalle.cuenta_destino,
              banco_destino: detalle.banco_destino,
              detalle: detalle.detalle,
              saldo: detalle.saldo,
              importe: detalle.importe,
              clasificador: `${detalle.clasificador.codigo} ${detalle.clasificador.nombre}`,
              cuenta_contable: detalle.clasificador.cuenta_contable
                ? `${detalle.clasificador.cuenta_contable.codigo} ${detalle.clasificador.cuenta_contable.nombre}`
                : '',
              // clasificador: detalle.clasificador.nombre,
              clasificador_id: detalle.clasificador.id,
              estado: detalle.estado,
              archivo_id: detalle.archivo_id,
            })),
          };

          break;
        }
        default: {
          window.console.log('No se reconoce la accion');
        }
      }

      await Promise.all(
        data['detalle_solicitud'].map(async (detalle, indice) => {
          await this.obtenerPartidaSaldo(detalle.sede_origen_id, detalle.clasificador_id, indice);
        }),
      );

      this.gridApi?.refreshCells();

      this.agregarDetalle = {
        cuenta_origen: null,
        cuenta_destino: null,
        detalle: null,
        saldo: 0,
        importe: '',
        clasificador: null,
      };

      this.getSedes();
      this.dialog = true;
    },
    actualizarEstdoDetalleSolicitud({ id, estado }) {
      const indiceDetalleSolicitud = this.form.detalle_solicitud.findIndex((detalle) => detalle.id === id);
      this.form.detalle_solicitud[indiceDetalleSolicitud].estado = estado;
      this.gridApi.refreshCells();
    },
  },
};

function numberParser(params) {
  if (!isNaN(params.newValue) && params.newValue >= 0) {
    return Number(params.newValue).toFixed(2);
  } else {
    return 0;
  }
}
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
.v-dialog {
  align-items: flex-start;
}
.ag-grid-table-procesar-solicitudes {
  height: calc(var(--vh, 1vh) * 100 - 22rem);
}
</style>
<style scoped>
::v-deep .col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-auto {
  width: 100%;
  padding: 8px;
}
hr {
  margin-top: 8px;
  margin-bottom: 10px;
  border: 0;
  border-top: 1px solid #eee;
}
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}
::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}
::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}
::v-deep .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-outer,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-inner,
.v-text-field--full-width.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__prepend-outer {
  margin-top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}

::v-deep .container,
.container-fluid {
  padding-right: 0px;
  padding-left: 0px;
}

::v-deep .container {
  width: 100%;
  padding: 0px;
  margin-right: auto;
  margin-left: auto;
}
</style>
  <style>
.mood {
  border-radius: 15px;
  border: 1px solid grey;
  background: #e6e6e6;
  padding: 15px;
  text-align: center;
  display: inline-block;
  outline: none;
}

.default {
  border: 1px solid transparent !important;
  padding: 4px;
}

.selected {
  border: 1px solid lightgreen !important;
  padding: 4px;
}

.simple-input-editor {
  width: 100%;
  height: 100%;
}
</style>
  